import PopupModal from "../../../../Components/PopupModal";
import InputLabel from "../../../../Components/FloatingLabel/FloatingLabel";
import { Button, Row, Col, Input, Form, Select, Spin, message } from "antd";
import React, { useState } from "react";
import "./GenerateChallanModal.css";
import PropTypes from "prop-types";

const { Item } = Form;
const { Option } = Select;
const GeneratePH10Modal = ({
  visible,
  initialPayableValue,
  onModalSubmit,
  onModalCancel,
  loading,
  initialArrearsValue,
}) => {
  const [arrearsValue, setArrearsValue] = useState(0);
  const [surchargeValue, setSurchargeValue] = useState(0);
  const [form] = Form.useForm();

  const [totalPayable, setTotalPayable] = useState(() => +initialPayableValue);
  const [type, setType] = useState("+");

  const types = ["+", "-"];
  React.useEffect(() => {
    if (initialArrearsValue) {
      if (initialArrearsValue >= 0) {
        setType("+");
        setArrearsValue(+initialArrearsValue);
        form.setFieldsValue({
          ...form.getFieldsValue(),
          arrears: +initialArrearsValue,
        });
      } else {
        setType("-");
        setArrearsValue(-initialArrearsValue);
        form.setFieldsValue({
          ...form.getFieldsValue(),
          arrears: -initialArrearsValue,
        });
      }
    } else {
      setArrearsValue(0);
      form.setFieldsValue({
        ...form.getFieldsValue(),
        arrears: 0,
      });
    }
  }, [initialArrearsValue]);
  React.useEffect(() => {
    const sum =
      (+arrearsValue ? arrearsValue : 0) +
      (+surchargeValue ? +surchargeValue : 0) +
      +initialPayableValue;
    setTotalPayable(sum);
  }, [arrearsValue, surchargeValue, initialPayableValue]);
  const onTypeChange = (type) => {
    setType(type);
    form.setFieldsValue({
      ...form.getFieldsValue(),
      arrears: 0,
    });
    setArrearsValue(0);
  };

  const arrearsValueOnChange = (e) => {
    let val = e.target.value;
    if (type === "-") {
      setArrearsValue(-parseInt(val));
    } else {
      setArrearsValue(+parseInt(+val));
    }
  };
  const surchargeValueOnChange = (e) => {
    const val = e.target.value;
    setSurchargeValue(+parseInt(val));
  };
  const numberInputRules = () => {
    return [
      {
        required: false,
        pattern: new RegExp(/^\d+$/g),
        message: "Value must involve only numbers",
      },
    ];
  };
  const finishHandler = () => {
    form
      .validateFields()
      .then((values) => {
        const outputFromComponent = {
          arrears: arrearsValue ? arrearsValue : 0,
          surcharge: surchargeValue ? surchargeValue : 0,
          totalPayable: totalPayable,
        };

        onModalSubmit(outputFromComponent);
        setTotalPayable(0);
        setArrearsValue(0);
        setSurchargeValue(0);
        form.resetFields();
      })
      .catch((info) => {});
  };
  const modalCancelHandler = () => {
    setTotalPayable(0);
    setArrearsValue(0);
    setSurchargeValue(0);
    form.resetFields();
    setType("+");
    onModalCancel();
  };
  return (
    <PopupModal
      title={"Create Challan"}
      centered
      visible={visible}
      destroyOnClose
      closable={false}
      className="challan-modal"
      onCancel={modalCancelHandler}
      footer={[
        <>
          <Button
            key="cancel"
            type="link"
            className="cancel-btn-create-challan"
            onClick={modalCancelHandler}
          >
            CANCEL
          </Button>
          <Button
            key="submit"
            type="link"
            onClick={finishHandler}
            loading={loading}
          >
            GENERATE CHALLAN
          </Button>
        </>,
      ]}
    >
      You are about to create a PH10 form for this property. Add surcharge
      and/or arrears if applicable.
      <Row gutter={[16, 0]}>
        <Form
          className="ph10-form-generate-wrapper"
          form={form}
          preserve={false}
        >
          <Col span={24}>
            <InputLabel value={surchargeValue} labelText="Surcharge" active={surchargeValue!==0?true:false}>
              <Item rules={numberInputRules()} name="surcharge">
                <Input
                  suffix="Rs."
                  size="large"
                  className="ph10-input-number"
                  onChange={surchargeValueOnChange}
                />
              </Item>
            </InputLabel>
          </Col>
          <Col span={24}>
            <Row gutter={[16, 0]}>
              <Col span={5}>
                {" "}
                <InputLabel value={type} labelText="Type">
                  <Select
                    onChange={onTypeChange}
                    defaultValue={type}
                    size="large"
                    // disabled
                  >
                    {types?.map((item) => (
                      <Option value={item}>{item}</Option>
                    ))}
                  </Select>
                </InputLabel>
              </Col>
              <Col span={19}>
                <InputLabel value={arrearsValue} labelText="Arrears" active>
                  <Item rules={numberInputRules()} name="arrears">
                    <Input
                      suffix="Rs."
                      // disabled
                      size="large"
                      className="ph10-input-number"
                      onChange={arrearsValueOnChange}
                    />
                  </Item>
                </InputLabel>
              </Col>
            </Row>
          </Col>
        </Form>
      </Row>
      <div className="total-payable-wrapper">
        <Row gutter={[16, 16]}>
          <Col span={24}>
            <div className="total-payable-section">Total Payable</div>
          </Col>
        </Row>
        <Row gutter={[16, 0]}>
          <Col span={24}>
            <div>Rs. {totalPayable}</div>
          </Col>
        </Row>
      </div>
    </PopupModal>
  );
};
GeneratePH10Modal.propTypes = {
  visible: PropTypes.bool.isRequired,
  initialPayableValue: PropTypes.number.isRequired,
  onModalSubmit: PropTypes.func.isRequired,
  onModalCancel: PropTypes.func.isRequired,
};

export default GeneratePH10Modal;
